<!-- Breadcrumb-->
<div class="row pt-2 pb-2">
	<div class="col-sm-9">
		<h4 class="page-title">Editor</h4>
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><a href="javaScript:;">Bulona</a>
			</li>
			<li class="breadcrumb-item"><a href="javaScript:;">Forms</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Editor</li>
		</ol>
	</div>
	<div class="col-sm-3">
		<div ngbDropdown class="btn-group float-sm-right">
			<button type="button" class="btn btn-outline-danger"><i class="fa fa-cog mr-1"></i> Setting</button>
			<button type="button" class="btn btn-danger" id="dropdownBasic5" ngbDropdownToggle> <span class="caret"></span>
			</button>
			<div ngbDropdownMenu aria-labelledby="dropdownBasic5"> 
				<a href="javaScript:;" ngbDropdownItem>Action</a>
				<a href="javaScript:;" ngbDropdownItem>Another action</a>
				<a href="javaScript:;" ngbDropdownItem>Something else here</a>
				<div class="dropdown-divider"></div> 
				<a href="javaScript:;" ngbDropdownItem>Separated link</a>
			</div>
		</div>
	</div>
</div>
<!-- End Breadcrumb-->
<div class="card">
	<div class="toolbar" id="toolbar-toolbar"> <span class="ql-formats">
      <select class="ql-font">
        <option selected=""></option>
        <option value="serif"></option>
        <option value="monospace"></option>
      </select>
      <select class="ql-size">
        <option value="small"></option>
        <option selected=""></option>
        <option value="large"></option>
        <option value="huge"></option>
      </select>
    </span>
		<span class="ql-formats">
      <button class="ql-bold"></button>
      <button class="ql-italic"></button>
      <button class="ql-underline"></button>
      <button class="ql-strike"></button>
    </span>
		<span class="ql-formats">
      <select class="ql-color"></select>
      <select class="ql-background"></select>
    </span>
		<span class="ql-formats">
      <button class="ql-list" value="ordered"></button>
      <button class="ql-list" value="bullet"></button>
      <select class="ql-align">
        <option selected=""></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
      </select>
    </span>
		<span class="ql-formats">
      <button class="ql-link"></button>
      <button class="ql-image"></button>
    </span>
	</div>
	<div id="editor-container">
		<h2>The standard Lorem Ipsum passage, used since the 1500s</h2>
		<br/>
		<p>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor <u>incididunt</u> ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea <strong>commodo</strong> consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse <u>cillum dolore eu fugiat nulla</u> pariatur. Excepteur <strong>occaecat cupidatat non proident</strong> , sunt in culpa qui officia deserunt mollit anim id est laborum."
			<br>
			<br>"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae consequatur, vel illum qui dolorem eum fugiat quo voluptas nulla pariatur?"</p>
	</div>
</div>